import { createSelector } from '@ngrx/store';

import { getNavigationState } from '../navigation.selectors';
import { ecmpLogosSelectorKey } from './ecmp-logos.reducer';
import type { EcmpAffiliateLogo } from './ecmp-logos.interface';

export const getEcmpLogosState = createSelector(
  getNavigationState,
  (state) => state[ecmpLogosSelectorKey]
);

export const getEcmpLogo = createSelector(getEcmpLogosState, (state) =>
  Object.keys(state).length === 0 ? null : (state as EcmpAffiliateLogo)
);
